import React, { useState, useContext } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { numberFormat } from '../../../helpers/helperFunctions';
import useClientCallOutDashboard from '../context/useClientCallOutDashboard';

export default function ClientCallOutDetailsTable() {
  const { cncDashboardDtl } = useContext(useClientCallOutDashboard);
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'name',
      headerName: ' ',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'actual',
      headerName: 'Actual',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => numberFormat(row.actual),
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => numberFormat(row.amount),
    },
  ];

  return (
    <Box
      className='table-container'
      sx={{
        height: `810px`,
        '& .super-app-theme--header': {
          backgroundColor: '#6B8D3E',
          color: '#fff',
        },

        '& .total': {
          backgroundColor: '#67ace7',
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#6B8D3E' },
      }}
    >
      <DataGridPro
        loading={cncDashboardDtl?.loading}
        rows={cncDashboardDtl?.table}
        columns={columns}
        sortModel={sortModel}
        initialState={{
          ...cncDashboardDtl?.table.initialState,
          pagination: {
            pageSize: 50,
          },
        }}
        rowsPerPageOptions={[10, 25, 50]}
        pagination
        onSortModelChange={(model) => setSortModel(model)}
        getRowClassName={(params) => params?.row?.user_type}
      />
    </Box>
  );
}
